<script>
export default {
    props: {
        jobApplication: {
            type: Object,
            required: true
        },
        divClass: {
            type: String,
            default: 'small-12 medium-6 large-4'
        }
    }
}
</script>

<template>
    <div class="grid-x grid-padding-x">
        <div class="cell" :class="divClass">
            <div class="form-control">
                <label>First Name</label>
                <input type="text" disabled :value="jobApplication.user.first_name" />
            </div>

            <div class="form-control">
                <label>Surname</label>
                <input type="text" disabled :value="jobApplication.user.last_name" />
            </div>

            <div class="form-control">
                <label>Known As</label>
                <input type="text" disabled :value="jobApplication.user.known_as" />
            </div>

            <div class="form-control">
                <label>Email Address</label>
                <input type="text" disabled :value="jobApplication.user.email" />
            </div>

            <div class="form-control">
                <label>Mobile Number</label>
                <input type="text" disabled :value="jobApplication.user.cellphone_1" />
            </div>

            <div class="form-control">
                <label>ID Number</label>
                <input type="text" disabled :value="jobApplication.user.id_number" />
            </div>

            <div class="form-control">
                <label>Province</label>
                <input type="text" disabled :value="jobApplication.user.province ? jobApplication.user.province.title : null" />
            </div>

            <div class="form-control">
                <label>Country</label>
                <input type="text" disabled :value="jobApplication.user.country ? jobApplication.user.country.title : null" />
            </div>

            <div class="form-control">
                <label>Address</label>
                <input type="text" disabled :value="jobApplication.user.address" />
            </div>

            <div class="form-control">
                <label>Ethnicity</label>
                <input type="text" disabled :value="jobApplication.user.ethnicity ? jobApplication.user.ethnicity.title : null" />
            </div>

            <div class="form-control">
                <label>Employment Status</label>
                <input type="text" disabled :value="jobApplication.user.employment_status ? jobApplication.user.employment_status.title : null" />
            </div>

            <div class="form-control">
                <label>Current Salary</label>
                <input type="text" disabled :value="jobApplication.user.current_salary" />
            </div>

            <div class="form-control">
                <label>Desired Salary</label>
                <input type="text" disabled :value="jobApplication.user.desired_salary" />
            </div>

            <div class="form-control mt-3">
                <label>Are you a citizen of the country you are seeking employment in?</label>
                <div>
                    <div class="d-flex align-items-center yes-no-item">
                        <input
                            type="radio"
                            value="1"
                            :disabled="!jobApplication.user.is_citizen"
                            :checked="!!jobApplication.user.is_citizen"
                        />

                        <label>
                            Yes
                        </label>
                    </div>

                    <div class="d-flex align-items-center yes-no-item">
                        <input
                            type="radio"
                            value="0"
                            :disabled="!!jobApplication.user.is_citizen"
                            :checked="!jobApplication.user.is_citizen"
                        />

                        <label>
                            No
                        </label>
                    </div>
                </div>

            </div>

            <div class="form-control">
                <label>ID Document</label>
                <input type="text" v-if="jobApplication.user.id_path" :value="`${jobApplication.user.id_path_cdn}`" disabled>
                <p class="fw-light" v-else>No file attached.</p>
            </div>

            <div class="form-control">
                <label>Drivers License</label>
                <a v-if="jobApplication.user.drivers_licence_path" target="_blank" :href="`${jobApplication.user.drivers_licence_path_cdn}`">{{ jobApplication.user.drivers_licence_path_cdn }}</a>
                <p class="fw-light" v-else>No file attached.</p>
            </div>

            <div class="form-control">
                <label>Do you have any disabilities or conditions? </label>
                <p class="fw-light mb-2">Eg. physical, mental, diabetes, epilepsy etc.</p>
                <div>
                    <div class="d-flex align-items-center yes-no-item">
                        <input
                            type="radio"
                            value="1"
                            :disabled="!jobApplication.user.disabilities_and_disorders"
                            :checked="!!jobApplication.user.disabilities_and_disorders"
                        />

                        <label>
                            Yes
                        </label>
                    </div>
                    <div class="form-control">
                        <input type="text" disabled :value="jobApplication.user.disabilities_and_disorders" />
                    </div>

                    <div class="d-flex align-items-center yes-no-item">
                        <input
                            type="radio"
                            value="0"
                            :disabled="!!jobApplication.user.disabilities_and_disorders"
                            :checked="!jobApplication.user.disabilities_and_disorders"
                        />

                        <label>
                            No
                        </label>
                    </div>
                </div>
            </div>

            <div class="form-control">
                <label>Have you ever worked for Merchants in the past? </label>
                <div>
                    <div class="d-flex align-items-center yes-no-item">
                        <input
                            type="radio"
                            value="1"
                            :disabled="!jobApplication.user.is_worked_for_merchant_in_the_past"
                            :checked="!!jobApplication.user.is_worked_for_merchant_in_the_past"
                        />

                        <label>
                            Yes
                        </label>
                    </div>
                    <div class="d-flex align-items-center yes-no-item">
                        <input
                            type="radio"
                            value="0"
                            :disabled="!!jobApplication.user.is_worked_for_merchant_in_the_past"
                            :checked="!jobApplication.user.is_worked_for_merchant_in_the_past"
                        />

                        <label>
                            No
                        </label>
                    </div>
                </div>
            </div>

            <div class="form-control">
                <label>Are you currently working for Merchantst? </label>
                <div>
                    <div class="d-flex align-items-center yes-no-item">
                        <input
                            type="radio"
                            value="1"
                            :disabled="!jobApplication.user.currently_working_for_merchant"
                            :checked="!!jobApplication.user.currently_working_for_merchant"
                        />

                        <label>
                            Yes
                        </label>
                    </div>
                    <div class="d-flex align-items-center yes-no-item">
                        <input
                            type="radio"
                            value="0"
                            :disabled="!!jobApplication.user.currently_working_for_merchant"
                            :checked="!jobApplication.user.currently_working_for_merchant"
                        />

                        <label>
                            No
                        </label>
                    </div>
                </div>
            </div>            

            <div class="form-control">
                <label>Were you referred by someone? </label>
                <div class="d-flex align-items-center yes-no-item">
                    <input
                        type="radio"
                        value="1"
                        :disabled="!jobApplication.user.is_referred"
                        :checked="!!jobApplication.user.is_referred"
                    />

                    <label>
                        Yes
                    </label>
                </div>
                <div v-if="jobApplication.user.is_referred" class="grid-x grid-padding-x" style="padding-left: 10px">
                    <div class="cell small-6 form-control">
                        <label>First Name</label>
                        <input type="text" disabled :value="jobApplication.user.referral_first_name" />
                    </div>

                    <div class="cell small-6 form-control">
                        <label>First Name</label>
                        <input type="text" disabled :value="jobApplication.user.referral_last_name" />
                    </div>
                </div>

                <label>Business Unit</label>
                <div class="form-control">
                    <input type="text" disabled :value="jobApplication.user.company ? jobApplication.user.company.title : null" />
                </div>

                <div class="d-flex align-items-center yes-no-item">
                    <input
                        type="radio"
                        value="0"
                        :disabled="!!jobApplication.user.is_referred"
                        :checked="!jobApplication.user.is_referred"
                    />

                    <label>
                        No
                    </label>
                </div>
            </div>
            
        </div>
    </div>
</template>
